import React, { useEffect } from 'react';
import { useUIStore } from '@/store/uiStore';
import { AppLocalEnum, getLanguage } from '@/translate/text';

const NotificationContainer = () => {
  const { notifications, removeNotification } = useUIStore();
  const language = getLanguage(localStorage.getItem('language')) || AppLocalEnum.EN;

  useEffect(() => {
    // Clean up notifications automatically
    const timers = notifications.map((notification) => {
      if (notification.duration) {
        return setTimeout(() => {
          removeNotification(notification.id);
        }, notification.duration);
      }
      return null;
    });

    // Cleanup function to clear all timers
    return () => {
      timers.forEach((timer) => {
        if (timer) clearTimeout(timer);
      });
    };
  }, [notifications, removeNotification]);

  return (
    <div className="toast-container position-fixed top-0 p-0 end-0 " style={{ zIndex: 1050 }}>
      {notifications.map((notification) => (
        <div
          key={notification.id} // Using the unique ID
          className={`toast align-items-center text-black bg-${notification.type || 'info'} border-0 show`}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="d-flex">
            <div className="toast-body text-black">
              <i
                className={`fas fa-${getNotificationIcon(notification.type)} ${language === AppLocalEnum.AR ? 'ms-2' : 'me-2'} `}
              ></i>
              {notification.message}
            </div>
            <button
              type="button"
              className={`btn-close btn-close-black m-auto ${language === AppLocalEnum.AR ? 'ms-2' : 'me-2'}`}
              onClick={() => removeNotification(notification.id)}
            ></button>
          </div>
        </div>
      ))}
    </div>
  );
};

const getNotificationIcon = (type) => {
  switch (type) {
    case 'success':
      return 'check-circle';
    case 'error':
      return 'exclamation-circle';
    case 'warning':
      return 'exclamation-triangle';
    default:
      return 'info-circle';
  }
};

export default NotificationContainer;
